import type { TonPastille } from './Pastille';

/**
 * Cycle du panier : constitué, exporté, transmis au partenaire, puis clôturé
 * quand tous ses ordres sont servis — ou par le back-office s'il reste partiel.
 */
export const TON_PANIER: Record<string, TonPastille> = {
  OUVERT: 'neutre',
  GENERE: 'attente',
  TRANSMIS: 'interface',
  CLOTURE: 'succes',
};

export const LIBELLE_PANIER: Record<string, string> = {
  OUVERT: 'Ouvert',
  GENERE: 'Généré',
  TRANSMIS: 'Transmis',
  CLOTURE: 'Clôturé',
};

/** Un panier transmis ou clôturé ne se transmet plus (RG-11). */
export const panierTransmissible = (statut: string) => statut === 'OUVERT' || statut === 'GENERE';
